import * as _ from 'lodash';

import { Model } from '../state/model';
import { EventModelStatus } from '../../../abstracts/event-status.type';

export function lowerWaveWithStatusLessThanApproved(models: Model[], compareWith: Model) {
  return _.find(models, model => +model.wave < +compareWith.wave && +EventModelStatus[model.status] < +EventModelStatus.Approved);
}
